import { NgModule } from '@angular/core';
import { ActionCenterComponent } from './action-center.component';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { SearchSortBar } from './components/search-sort-bar/search-sort-bar.component';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { TvdBoxComponent } from './components/tvd-box/tvd-box.component';
import { SalesOpportunityBoxComponent } from './components/sales-opportunity-box/sales-opportunity-box.component';
import { EbrCoreModule } from 'src/app/core/components/ebr-core.module';
import { MatTabsModule } from '@angular/material/tabs';
import { ActionsHeaderComponent } from './components/actions-header/actions-header.component';
import { ActionsGridComponent } from './components/actions-grid/actions-grid.component';
import { TableRowComponent } from './components/actions-grid/components/table-row/table-row.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { ActionDetailsComponent } from './components/action-details/action-details.component';
import { RowActionComponent } from './components/actions-grid/components/table-row/row-action/row-action.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { SnoozeFormComponent } from './components/actions-grid/components/table-row/snooze-form/snooze-form.component';
import { DismissFormComponent } from './components/actions-grid/components/table-row/dismiss-form/dismiss-form.component';
import { TotalValueDeliveryModule } from '../total-value-delivery/total-value-delivery.module';

@NgModule({
  declarations: [
    ActionCenterComponent,
    ActionsGridComponent,
    ActionsHeaderComponent,
    ActionDetailsComponent,
    TableRowComponent,
    RowActionComponent,
    SnoozeFormComponent,
    DismissFormComponent,
    SearchSortBar,
    TvdBoxComponent,
    SalesOpportunityBoxComponent
  ],
  exports: [
    ActionCenterComponent
  ],
  imports: [
    EbrCoreModule,
    CommonModule,
    AppRoutingModule,
    FormsModule,
    SharedModule,
    MatSelectModule,
    SlickCarouselModule,
    MatTabsModule,
    MatPaginatorModule,
    TotalValueDeliveryModule
  ]
})
export class ActionCenterModule { }


